export default {
  isLoading: false,
  principals: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  category: {},
  status: null
};
